<template>
  <v-flex xs12>
    <Diccionario :id_unit="this.idUnidad" :isPractice="true"/>
    <v-card class="e-practicaCarousel transparent elevation-0">
      <v-card-title>
         <p class="p-normal text-xs-left" v-html="loadedLessons.instructions_spanish"></p>
      </v-card-title>
      <v-card-text class="pt-0">
        <div class="px-3 mb-4" style="position: relative">
          <v-card class="radius e-practicaCarousel-card align-center d-flex e-elevation--4">
            <v-card-text class="py-4 px-4">
              <p class="e-description-middle text-xs-center mb-0" v-html="loadedLessons.exercise"></p>
            </v-card-text>
          </v-card>
          <div class="e-practicaCarousel-rate">
            <v-btn fab color="white grey-lightness--text" @click="correcto = !correcto" >
              <v-icon :class="correcto ? 'grey-lightness--text' : 'yellow--text'">favorite</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="px-3">
          <carousel 
            :loop="false" 
            :items="1" 
            :margin="10" 
            :center="true" 
            :dots="false" 
            :nav="false" 
            class="e-carousel--unidad" >
            <CardCarousel 
              v-for="(lesson, index) in loadedLessons.options" :key="`textCaro-${index}`"
              :descripcion="lesson"
              :number="(index + 1)"
            />
          </carousel>
        </div>
      </v-card-text>
      <v-card-actions class="px-3">
        <v-btn
        round
        large
        router-link
        :to="`/practica/intermedio/${idUnidad}/ejercicio/separador`"
        color="primary">
          COMPROBAR
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import CardCarousel from '../../../components/Practica/intermedio/CardCarousel'
import { storeFirebase } from '../../../store/firebase'

export default {
  name: 'PracticaCarousel',
  props: ['idUnidad'],
  data () {
    return {
      correcto: true
    }
  },
  created () {
    this.loadLessons()
  },
  computed: {
    loadedLessons () {
      const dataValues = storeFirebase.getters.loadedPracticeLessons
      const data = dataValues.filter(data => data.id_tipo_ejercicio == 6)
      if(data.length === 0) {
        const dataTemp = {
          instructions_spanish: '',
          exercise: '',
          options: []
        }
        return dataTemp
      }
      return data[0]
    }
  },
  methods: {
    check() {
      this.correcto = !this.correcto
    },
    loadLessons () {
      const payload = {
        id_unit: Number(this.idUnidad),
        id_practice: 2
      }
      storeFirebase.dispatch("loadPracticeLessons", payload)
    }
  },
  components: {
    CardCarousel
  }
}
</script>

